import { useState, useMemo } from "react";
import PropTypes from "prop-types";

import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

function isImageUrl(url) {
  return /\.(png|jpe?g|gif|webp|bmp|svg|avif)$/i.test(url || "");
}

export default function MediaGallery({ media, title = "M�dias", showTitle = true, gridProps }) {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const images = useMemo(() => media.filter((m) => isImageUrl(m.url)), [media]);

  const openLightbox = (indexInAll) => {
    const url = media[indexInAll]?.url;
    const imageIndex = images.findIndex((m) => m.url === url);
    if (imageIndex >= 0) {
      setPhotoIndex(imageIndex);
      setIsOpen(true);
    }
  };

  if (!media || media.length === 0) return null;

  return (
    <>
      {showTitle && (
        <MKTypography variant="h5" mt={2} mb={1}>
          {title}
        </MKTypography>
      )}

      <Grid container spacing={2} {...gridProps}>
        {media.map((m, idx) => {
          const img = isImageUrl(m.url);
          return (
            <Grid item xs={6} sm={4} md={3} key={`${m.url}-${idx}`}>
              {img ? (
                <MKBox
                  component="img"
                  src={m.url}
                  alt={m.label || `media-${idx}`}
                  width="100%"
                  onClick={() => openLightbox(idx)}
                  sx={{
                    cursor: "pointer",
                    display: "block",
                    borderRadius: 1,
                  }}
                />
              ) : (
                <MKBox display="flex" flexDirection="column" alignItems="center">
                  <IconButton href={m.url} target="_blank" rel="noopener noreferrer" download>
                    <InsertDriveFileIcon />
                  </IconButton>
                  <MKTypography
                    variant="body2"
                    sx={{ textAlign: "center", maxWidth: "100%", wordBreak: "break-word" }}
                  >
                    {m.label || m.url}
                  </MKTypography>
                </MKBox>
              )}
            </Grid>
          );
        })}
      </Grid>

      {isOpen && images.length > 0 && (
        <Lightbox
          mainSrc={images[photoIndex].url}
          nextSrc={images[(photoIndex + 1) % images.length].url}
          prevSrc={images[(photoIndex + images.length - 1) % images.length].url}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
          onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
        />
      )}
    </>
  );
}

MediaGallery.propTypes = {
  media: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      label: PropTypes.string,
    })
  ).isRequired,
  title: PropTypes.string,
  showTitle: PropTypes.bool,
  gridProps: PropTypes.object,
};
